import images from "@assets/logo/images";
import Image from "@components/Image";
import useLocales from "@hooks/useLocales";
import { Button } from "@mui/material";
import { closePanel, openPanel, togglePanel } from "@redux/slices/askDostChat";
import { RootState, useDispatch, useSelector } from "@redux/store";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { AskDostDrawer } from "./drawers/AskDostDrawer";
import { loginToAskDost } from "../services/askDostService";
import { useAskDostStyles } from "../styles/askDostStyles";

const hasCookie = (name: string): boolean => {
  const cookies = document.cookie.split("; ");
  return cookies.some((cookie) => cookie.startsWith(`${name}=`));
};

export const AskDost = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isOpen = useSelector(
    (state: RootState) => state.askDostChat.isPanelOpen,
  );
  const { translate } = useLocales("ask_dost_screen");
  const [error, setError] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const { askDostButton } = useAskDostStyles({});
  const isAskDostFullScreen = location.pathname.includes("/dashboard/ask-dost");

  useEffect(() => {
    if ((location.state as any)?.openAskDost === true) {
      dispatch(openPanel());
    }
  }, [location.state, dispatch]);

  const handleCloseDrawer = () => {
    dispatch(closePanel());
  };

  const handleLoginToAskDost = async () => {
    const res = await loginToAskDost();
    if (res && res?.status !== 200) {
      setError(res.data.detail as string);
    }
  };

  useEffect(() => {
    if (!hasCookie("askdost_chat")) {
      handleLoginToAskDost();
    }
  }, []);

  return (
    <>
      <Button
        variant="outlined"
        size="medium"
        onClick={() => {
          if (isAskDostFullScreen) {
            return;
          }

          if (error) {
            enqueueSnackbar(error, { variant: "error" });
            return;
          }
          dispatch(togglePanel());
        }}
        sx={askDostButton}
        endIcon={<Image src={images.askDost} loading="lazy" />}
      >
        Ask Dost
      </Button>

      <AskDostDrawer
        isOpen={isOpen}
        translate={translate}
        onClose={handleCloseDrawer}
        initialData={(location.state as any)?.data}
        initialPendingUploads={(location.state as any)?.pendingUploads}
      />
    </>
  );
};
